$(document).ready(function () {
    var currencySymbol = $('#currencySymbolForJs').val();
    

});
